// ABOUTME: Mobile phoneView card for Amazon FBA replenishment rows in the warehouse orders grid.
// ABOUTME: Mirrors BolLvbCard, swapping in the Amazon replenishment state map.
import { Box, useTheme } from "@mui/material"
import BaseCard from "../../../theme/cards/BaseCard"
import { tokens } from "../../../../theme";
import Text from "../../../theme/text/Text";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import { getAmazonReplenishmentStateData } from "../../../../utils/labelColorText";
import Subheading from "../../../theme/text/Subheading";
import { calculateBusinessDays, getDaysColorVariant } from "../../../../environments/warehouse/outbound/orders/views/Bol";

const AmazonFbaCard = (props) => {
    const { t,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [statusColor, setStatusColor] = useState("blue");
    const [statusText, setStatusText] = useState("");
    const [businessDays, setBusinessDays] = useState(null);

    useEffect(() => {
        if(!props.skeleton) {
            const { labelcolor, labeltext } = getAmazonReplenishmentStateData(props.state, theme);
            setStatusColor(labelcolor);
            setStatusText(t(labeltext));
            setBusinessDays(calculateBusinessDays(props.createdAt));
        }

    },[props.skeleton])

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box
                >
                    <Box display={"flex"} flexDirection={"column"}>
                        {props.skeleton ?
                            <ShDoubleTextSkeleton/>
                            :
                            <>
                                <Text black>{props.reference ?? props.barcode ?? props.id}</Text>
                                <Text>{props.relation?.name}</Text>
                                <Text light>{props.webshopcredentials?.description ?? t("self_created")}</Text>
                            </>
                        }
                    </Box>
                    <TopRight>
                        <CardLabel
                            variant={props.skeleton ? "grey" : statusColor}
                            position="child-tr"
                            hasright={props.state === "open"}
                        >
                            {statusText}
                        </CardLabel>
                        {props.state === "open" &&

                            <CardLabel
                                hasleft
                                background={theme.palette.mode === "dark" ?  colors.txt["secondary"] : null}
                                color={theme.palette.mode === "dark" ? colors.txt["primary"] : null}
                                variant={businessDays !== null ? getDaysColorVariant(businessDays) : theme.palette.mode === "dark" ? "greyLight" : "grey"}
                                position="child-tr"
                            >
                                {props.skeleton ? null :
                                   businessDays
                                }
                            </CardLabel>

                        }
                    </TopRight>

                    <Box marginTop={3} display={"flex"} alignItems={"flex-start"} gap={3} overflow={"hidden"}>
                        <Box display={"flex"} flexDirection={"column"}>
                            <Text light>{t("products")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Subheading noBreak>
                                    {props.amountOfLines}
                                </Subheading>
                            }
                        </Box>
                        <Box display={"flex"} flexDirection={"column"}>
                            <Text light>{t("items")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Subheading noBreak>
                                    {props.amountOfItems}
                                </Subheading>
                            }
                        </Box>

                        <Box display={"flex"} flexDirection={"column"} ml="auto">
                            <Text noBreak light>{t("date_created")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Box>
                                    <Text semibold>{new Date(props.createdAt).toLocaleDateString(i18n.language, { dateStyle: 'short' })}</Text>&nbsp;&nbsp;
                                    <Text>{new Date(props.createdAt).toLocaleTimeString(i18n.language, { timeStyle: 'short' })}</Text>
                                </Box>
                            }
                        </Box>

                    </Box>


                </Box>
            </Box>
        </BaseCard>
    )
}

export const AmazonFbaRelationCard = (props) => {
    const { t,i18n } = useTranslation();
    const theme = useTheme();
    const [statusColor, setStatusColor] = useState("blue");
    const [statusText, setStatusText] = useState("");

    useEffect(() => {
        if(!props.skeleton) {
            const { labelcolor, labeltext } = getAmazonReplenishmentStateData(props.state, theme);
            setStatusColor(labelcolor);
            setStatusText(t(labeltext));
        }

    },[props.skeleton])

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box
                >
                    <Box display={"flex"} flexDirection={"column"}>
                        {props.skeleton ?
                            <ShDoubleTextSkeleton/>
                            :
                            <>
                                <Text black>{props.reference ?? props.barcode ?? props.id}</Text>
                                <Text>{props.relation?.name}</Text>
                                <Text light>{props.webshopcredentials?.description ?? t("self_created")}</Text>
                            </>
                        }
                    </Box>
                    <TopRight>
                        <CardLabel
                            variant={props.skeleton ? "grey" : statusColor}
                            position="child-tr"
                        >
                            {statusText}
                        </CardLabel>
                    </TopRight>

                    <Box marginTop={3} display={"flex"} alignItems={"flex-start"} gap={3} overflow={"hidden"}>
                        <Box display={"flex"} flexDirection={"column"}>
                            <Text light>{t("products")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Subheading noBreak>
                                    {props.amountOfLines}
                                </Subheading>
                            }
                        </Box>
                        <Box display={"flex"} flexDirection={"column"}>
                            <Text light>{t("items")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Subheading noBreak>
                                    {props.amountOfItems}
                                </Subheading>
                            }
                        </Box>

                        {props.state !== "open" &&
                            <Box display={"flex"} flexDirection={"column"} ml="auto">
                                <Text noBreak light>{t("date_created")}</Text>

                                {props.skeleton ?
                                    <ShTextSkeleton />
                                    :
                                    <Box>
                                        <Text semibold>{new Date(props.createdAt).toLocaleDateString(i18n.language, { dateStyle: 'short' })}</Text>&nbsp;&nbsp;
                                        <Text>{new Date(props.createdAt).toLocaleTimeString(i18n.language, { timeStyle: 'short' })}</Text>
                                    </Box>
                                }
                            </Box>
                        }

                    </Box>


                </Box>
            </Box>
        </BaseCard>
    )
}

export default AmazonFbaCard;
